// src/consent-scripts.js
//
// Consent-gated scripts and the vendor list for the checkout consent modal.
// SalesPark's own GA4 tag (previously an ungated inline gtag in public/index.html)
// now loads only after the visitor grants "analytics". Producer pixels (Meta / GA4
// / GTM) are per-product and gated at fire time in utils/pixels.js; they are listed
// here only so their per-vendor switches show up in the preferences panel.
//
// History:
// 21-09-2026: Created (GA4 moved out of index.html into a consent-gated script)

import { VENDOR_CATALOG } from "@salespark/consent-gate/vendor";

/****************************************************
 * ##: SalesPark checkout GA4 loader
 * Injects gtag.js and configures the measurement id. Browser only, runs once (the
 * gate dedupes by script id), after the "analytics" category is granted.
 * @param {String} id - GA4 measurement id
 * History:
 * 21-09-2026: Created
 ****************************************************/
const loadGtag = (id) => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", id);
};

// Single source of truth for anything that must not run before a consent decision.
export const scripts = [
  {
    id: "salespark-ga4",
    category: "analytics",
    vendor: "ga4",
    load: () => loadGtag("G-2G3LF5R801"),
  },
];

// Vendors shown as per-category switches in the modal preferences. Only what the
// checkout can actually load: SalesPark + producer GA4 / GTM (analytics) and Meta
// Pixel + Conversions API (marketing).
const USED_VENDOR_IDS = ["ga4", "gtm", "meta-pixel", "meta-conversions-api"];
export const vendors = VENDOR_CATALOG.filter((v) => USED_VENDOR_IDS.includes(v.id));
